var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnergyDrinks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Soft-Drinks-Can-Energy--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Soft Drinks Can Energy Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 6h10a1 1 0 0 0 0 -2h-6.15a0.5 0.5 0 0 1 -0.43 -0.24L9.36 2a1 1 0 0 0 -1.83 0.27 0.94 0.94 0 0 0 0.11 0.73l0.36 0.62a0.28 0.28 0 0 1 0 0.25 0.25 0.25 0 0 1 -0.21 0.13H7a1 1 0 0 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.75a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 1 0 -1.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2a0.75 0.75 0 1 0 1.5 0A0.75 0.75 0 1 0 14 2",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3A0.75 0.75 0 1 0 13 3a0.75 0.75 0 1 0 -1.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.91 9.59 -1.76 -1.93a0.52 0.52 0 0 0 -0.37 -0.16H8.22a0.52 0.52 0 0 0 -0.37 0.16L6.09 9.59A2 2 0 0 0 5.5 11v9.38a5.14 5.14 0 0 0 0.82 2.78A1.94 1.94 0 0 0 8 24h8a2 2 0 0 0 1.64 -0.84 5.16 5.16 0 0 0 0.82 -2.78V11a2 2 0 0 0 -0.55 -1.41Zm-2.59 6.15 -3.94 4.59a0.52 0.52 0 0 1 -0.38 0.17 0.47 0.47 0 0 1 -0.17 0 0.5 0.5 0 0 1 -0.33 -0.5v-3a0.5 0.5 0 0 0 -0.5 -0.5h-0.75a0.75 0.75 0 0 1 -0.68 -0.44 0.76 0.76 0 0 1 0.11 -0.8l3.94 -4.59a0.52 0.52 0 0 1 0.55 -0.14 0.5 0.5 0 0 1 0.33 0.47v3a0.5 0.5 0 0 0 0.5 0.5h0.75a0.75 0.75 0 0 1 0.68 0.44 0.76 0.76 0 0 1 -0.11 0.8Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnergyDrinks);
export default ForwardRef;